import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthProvider';

/**
 * Conditionally mounts Auth0Provider.
 *
 * auth0-spa-js throws "must run on a secure origin" when the page is served
 * over plain HTTP from a non-localhost host (e.g. a LAN IP during mobile dev).
 *
 * The /bridge route and any subsequent navigation within a bridge session must
 * skip Auth0 entirely — the bridge token (stored in sessionStorage) handles
 * authentication for the whole session.
 */
export function ConditionalAuthProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  // A bridge session is active when:
  //  (a) we're on the /bridge path (token not yet set), OR
  //  (b) a bridge token already exists in sessionStorage (token set, navigated away)
  const isBridgeSession =
    pathname === '/bridge' || window.sessionStorage.getItem('tilly_bridge_token') !== null;

  if (isBridgeSession) {
    return <>{children}</>;
  }
  return <AuthProvider>{children}</AuthProvider>;
}
